import { z } from "zod";

export const businessProfileSchema = z.object({
  name: z
    .string()
    .min(1, "Business name is required")
    .max(100, "Business name must be less than 100 characters"),
  description: z
    .string()
    .min(1, "Description is required")
    .max(500, "Description must be less than 500 characters"),
  website: z
    .string()
    .url("Please enter a valid website URL")
    .optional()
    .or(z.literal("")),
  industry: z.string().min(1, "Industry is required"),
  designation: z.string().min(1, "Designation is required"),
  company_size: z.string().min(1, "Company size is required"),
  contact_info: z.object({
    email: z.string().min(1, "Business email is required").email("Please enter a valid email address"),
    phone: z.string().min(1, "Phone number is required"),
    address: z.object({
      line1: z.string().min(1, "Address line 1 is required"),
      line2: z.string().optional(),
      city: z.string().min(1, "City is required"),
      state: z.string().min(1, "State is required"),
      postal_code: z.string().min(1, "Postal code is required"),
      country: z.string().min(1, "Country is required"),
    }),
  }),
});

export type BusinessProfileFormData = z.infer<typeof businessProfileSchema>;